module.exports = __webpack_public_path__ + "img/mv-tommy.e11cb35d.png";